module.exports = __webpack_public_path__ + "img/项目实施方法论.9cbd35b5.svg";